import { AppPermissionTypeModel } from '../../../microsoft/azuread/profile/app-permission-type-model';

export class AzureADAppPermissionScopeModel {
  scope: string;
  type: AppPermissionTypeModel;
  description: string;
}
